"use client";
import React from "react";
import ShopNavigationColumn from "./ShopNavigationColumn";
import MenuCallToActionButton from "../../common/components/MenuCallToActionButton";
import MobileBackButton from "../../common/components/MobileBackButton";
import useNavigationStack from "../../common/utils/useNavigationStack";

const ShopLayout = ({
  data = {},
  backToMainMenu = null,
}: {
  data: any;
  navigationStack?: any[];
  backToMainMenu?: (item?: any) => void;
  config?: {
    callToAction?: any;
  };
}) => {
  const { back, navigationStack, handleNavigateTo, callToAction } =
    useNavigationStack(data, backToMainMenu);

  return (
    <div className="mkt-sub-nav full-width">
      <div className="container container-narrow">
        <MobileBackButton onClick={back} />
        <ShopNavigationColumn
          navigationStack={navigationStack}
          onNavigateTo={handleNavigateTo}
        />
        <MenuCallToActionButton callToAction={callToAction} />
      </div>
    </div>
  );
};

export default ShopLayout;
